import React from 'react';
import { Box, Button, Checkbox, FormControlLabel } from '@mui/material';
import { ArrowBack, ArrowForward, Flag } from '@mui/icons-material';

interface NavigationControlsProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  isMarkedForReview: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onMarkForReview: (marked: boolean) => void;
}

const NavigationControls: React.FC<NavigationControlsProps> = ({
  currentQuestionIndex,
  totalQuestions,
  isMarkedForReview,
  onPrevious,
  onNext,
  onMarkForReview
}) => {

  return (
    <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      mt: 3,
      p: 2,
      bgcolor: '#f5f5f5',
      borderRadius: 1,
      position: 'relative'
    }}
    >
      <Button
        variant="contained"
        startIcon={<ArrowBack />}
        onClick={onPrevious}
        disabled={currentQuestionIndex === 0}  // ← This makes it grey on first question
        className="test-button-primary"
        sx={{
          minWidth: '90px',
          '&:disabled': {
            backgroundColor: '#ccc'
          }
        }}
      >
        Prev
      </Button>

      <FormControlLabel
        control={
          <Checkbox
            checked={isMarkedForReview}
            onChange={(e) => onMarkForReview(e.target.checked)}
            icon={<Flag />}
            checkedIcon={<Flag sx={{ color: '#ff9800' }} />}
          />
        }
        label=""
        sx={{
          position: 'absolute',
          left: '53%',
          transform: 'translateX(-50%)'
        }}
      />

      <Button
        variant="contained"
        endIcon={<ArrowForward />}
        onClick={onNext}
        disabled={currentQuestionIndex === totalQuestions - 1}
        className="test-button-primary"
        sx={{
          minWidth: '90px',
          marginLeft: 'auto',
          '&:disabled': {
            backgroundColor: '#ccc'
          }
        }}
      >
        Next
      </Button>
    </Box>
  );
};

export default NavigationControls;